
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Homepage/Home";
import About from "./pages/Aboutpage/About";
import Contact from "./pages/Contactpage/Contact";
import Service from "./pages/servicepage/Services";
import Header from "./Component/Header";
import Insights from "./pages/Insightspage/Insights";
import HealthPlans from "./pages/servicepage/Patient-Centered Software Solutions";
import Teckstacks from "./pages/Teck stack/teckstacks";
import HealthcareIntegration from "./pages/servicepage/ourservices/HealthcareIntegration";
import Custom from "./pages/servicepage/ourservices/Custom";
import Ehr from "./pages/servicepage/ourservices/Ehr";
import Lis from "./pages/servicepage/ourservices/Lis";
import Hl7 from "./pages/servicepage/ourservices/Hl7";
import Fhirhealth from "./pages/servicepage/ourservices/Fhirhealth";
import MirthConnect from "./pages/servicepage/ourservices/MirthConnect";
import Telemedicine from "./pages/servicepage/ourservices/Telemedicine";
import Hiippa from "./pages/servicepage/ourservices/Hiippa";
import HDA from "./pages/servicepage/ourservices/AdvanceHDA";
import Revenue from "./pages/servicepage/ourservices/Revenue";
import ADHI from "./pages/servicepage/ourservices/AI-Driven-Healthcare-Innovations";
import PPES from "./pages/servicepage/ourservices/PPES";
import BlockchainPoweredHealthcareSecurity from "./pages/servicepage/ourservices/Blockchain-Powered-Healthcare-Security";
import Healthsoftware from "./pages/servicepage/Healthsoftware";
import RCM from "./pages/servicepage/HealthSoftware/Revenuecyclemanagement";
import HealthcareAnalytics from "./pages/servicepage/HealthSoftware/HealthcareAnalytics";
import PatientFlowManagement from "./pages/servicepage/HealthSoftware/PatientFlowManagement";
import EHR from "./pages/servicepage/HealthSoftware/Clinical Health Records";
import Tele from "./pages/servicepage/HealthSoftware/Telemedicine";
import CDS from "./pages/servicepage/HealthSoftware/CDS";
import HTI from "./pages/servicepage/Interoperability Solutions";
import Digitalhealth from "./pages/servicepage/HealthcareTechnology/Digitalhealthstartup";
import Ai from "./pages/servicepage/HealthcareTechnology/AI";
import Telehealth from "./pages/servicepage/HealthcareTechnology/Telehealth";
import ElectronicHealthRecords from "./pages/servicepage/HealthcareTechnology/EHR";
import Biotech from "./pages/servicepage/HealthcareTechnology/Biotech";
import Blockchaincybersecurity from "./pages/servicepage/HealthcareTechnology/Blockchain";
import PMG from "./pages/servicepage/HealthcareTechnology/PMG";
import HVC from "./pages/servicepage/HealthcareTechnology/HVC";
import RMSCT from "./pages/servicepage/HealthcareTechnology/RMSCT";
import HealthcareDataSecurity from "./pages/servicepage/Provider & Payer Systems";
import Dataencryption from "./pages/servicepage/DataSecurity/DataEncryption";
import AccessControl from "./pages/servicepage/DataSecurity/AccessControl";
import Securecloudstorage from "./pages/servicepage/DataSecurity/SecureCloudStorage";
import CTM from "./pages/servicepage/DataSecurity/CTM";
import PPP from "./pages/servicepage/DataSecurity/Patient";
import IR from "./pages/servicepage/DataSecurity/IncidentResponse&Recovery";
import HealthcareProvider from "./pages/servicepage/Clinical Systems";
import PLS from "./pages/servicepage/Health Data Security & Compliance";
import PrimaryCarePhysicians from "./pages/servicepage/HealthcareProvider/PCP";
import Hospitalclinics from "./pages/servicepage/HealthcareProvider/Hospitals&Clinics";
import SpecializedCare from "./pages/servicepage/HealthcareProvider/SpecializedCare";
import MedicalRecords from "./pages/servicepage/HealthcareProvider/MedicalRecords";
import EmergencyServices from "./pages/servicepage/HealthcareProvider/EmergencyServices";
import PreventiveHealthcare from "./pages/servicepage/HealthcareProvider/PreventiveHealthcare";
import CMSMandates from "./pages/servicepage/Healthplans/cms";
import BlueButton from "./pages/servicepage/Healthplans/BlueButtons";
import ConsentManagement from "./pages/servicepage/Healthplans/Consentmanagement";
import Comprehensive from "./pages/servicepage/Healthplans/Comprehensive";
import Secure from "./pages/servicepage/Healthplans/Secure&Affordable";
import Easyclams from "./pages/servicepage/Healthplans/Easyclams";
import Interoperability from "./pages/servicepage/Healthplans/Interoperability";
import Payer from "./pages/servicepage/Healthplans/Payer";
import DrugDevelopment from "./pages/servicepage/Pharmaceutical/DrugDevelopment";
import ClinicalTrials from "./pages/servicepage/Pharmaceutical/ClinicalTrials";
import RegulatoryCompliance from "./pages/servicepage/Pharmaceutical/RegulatoryCompliance";
import BiotechnologyResearch from "./pages/servicepage/Pharmaceutical/BiotechnologyResearch";
import PharmaceuticalManufacturing from "./pages/servicepage/Pharmaceutical/PharmaceuticalManufacturing";
import SupplyChainLogistics from "./pages/servicepage/Pharmaceutical/SupplyChainLogistics";
import PersonalizedMedicine from "./pages/servicepage/Pharmaceutical/PersonalizedMedicine";
import DigitalHealthSolutions from "./pages/servicepage/Pharmaceutical/DigitalHealthSolutions";
import PharmacovigilanceDrugSafety from "./pages/servicepage/Pharmaceutical/PharmacovigilanceDrugSafety";

function App() {
  return (
    <BrowserRouter>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/About" element={<About />} />
        <Route path="/Contact" element={<Contact />} />
        <Route path="/Services" element={<Service />}>
        </Route>
        <Route path="/insights" element={<Insights />} />
        <Route path="/teckstacks" element={<Teckstacks />} />
        
        {/* Health plan PLS */}
        <Route path="/Services/HealthDataSecurity&Compliance" element={<PLS />} />
        <Route path="/Services/HealthDataSecurity&Compliance/DrugDevelopment" element={<DrugDevelopment />} />
        <Route path="/Services/HealthDataSecurity&Compliance/ClinicalTrials" element={<ClinicalTrials />} />
        <Route path="/Services/HealthDataSecurity&Compliance/RegulatoryCompliance" element={<RegulatoryCompliance />} />
        <Route path="/Services/HealthDataSecurity&Compliance/BiotechnologyResearch" element={<BiotechnologyResearch />} />
        <Route path="/Services/HealthDataSecurity&Compliance/PharmaceuticalManufacturing" element={<PharmaceuticalManufacturing />} />
        <Route path="/Services/HealthDataSecurity&Compliance/SupplyChainLogistics" element={<SupplyChainLogistics />} />
        <Route path="/Services/HealthDataSecurity&Compliance/PersonalizedMedicine" element={<PersonalizedMedicine />} />
        <Route path="/Services/HealthDataSecurity&Compliance/DigitalHealthSolutions" element={<DigitalHealthSolutions />} />
        <Route path="/Services/HealthDataSecurity&Compliance/PharmacovigilanceDrugSafety" element={<PharmacovigilanceDrugSafety />} />
        {/* Health care Data security */}
        <Route path="/Services/Provider&PayerSystems" element={<HealthcareDataSecurity />} />
        <Route path="/Services/Provider&PayerSystems/DataEncryption" element={<Dataencryption />} />
        <Route path="/Services/Provider&PayerSystems/AccessControl" element={<AccessControl />} />
        <Route path="/Services/Provider&PayerSystems/SecureCloudStorage" element={<Securecloudstorage />} />
        <Route path="/Services/Provider&PayerSystems/CTM" element={<CTM />} />
        <Route path="/Services/Provider&PayerSystems/Patient" element={<PPP />} />
        <Route path="/Services/Provider&PayerSystems/IncidentResponse&Recovery" element={<IR />} />
        {/* Healthcare provider */}
        <Route path="/Services/ClinicalSystems" element={<HealthcareProvider />} />
        <Route path="/Services/ClinicalSystems/PCP" element={<PrimaryCarePhysicians />} />
        <Route path="/Services/ClinicalSystems/Hospitals&Clinics" element={<Hospitalclinics />} />
        <Route path="/Services/ClinicalSystems/SpecializedCare" element={<SpecializedCare />} />
        <Route path="/Services/ClinicalSystems/MedicalRecords" element={<MedicalRecords />} />
        <Route path="/Services/ClinicalSystems/EmergencyServices" element={<EmergencyServices />} />
        <Route path="/Services/ClinicalSystems/PreventiveHealthcare" element={<PreventiveHealthcare />} />
        {/* healthcare software  */}
        <Route path="/Services/Healthsoftware" element={<Healthsoftware />} />
        <Route path="/Services/HealthSoftware/Revenuecyclemanagement" element={<RCM />} />
        <Route path="/Services/HealthSoftware/HealthcareAnalytics" element={<HealthcareAnalytics />} />
        <Route path="/Services/HealthSoftware/PatientFlowManagement" element={<PatientFlowManagement />} />
        <Route path="/Services/HealthSoftware/Telemedicine" element={<Tele />} />
        <Route path="/Services/HealthSoftware/CDS" element={<CDS />} />
        <Route path="/Services/HealthSoftware/ClinicalHealthRecords" element={<EHR />} />
        {/* healthcare technology */}
        <Route path="/Services/InteroperabilitySolutions" element={<HTI />} />
        <Route path="/Services/InteroperabilitySolutions/Digitalhealthstartup" element={<Digitalhealth />} />
        <Route path="/Services/InteroperabilitySolutions/AI" element={<Ai />} />
        <Route path="/Services/InteroperabilitySolutions/Telehealth" element={<Telehealth />} />
        <Route path="/Services/InteroperabilitySolutions/EHR" element={<ElectronicHealthRecords />} />
        <Route path="/Services/InteroperabilitySolutions/Biotech" element={<Biotech />} />
        <Route path="/Services/InteroperabilitySolutions/Blockchain" element={<Blockchaincybersecurity />} />
        <Route path="/Services/InteroperabilitySolutions/PMG" element={<PMG />} />
        <Route path="/Services/InteroperabilitySolutions/HVC" element={<HVC />} />
        <Route path="/Services/InteroperabilitySolutions/RMSCT" element={<RMSCT />} />
        {/* Health Plans */}
        <Route path="/Services/Patient-CenteredSoftwareSolutions" element={<HealthPlans />} />
        <Route path="/Services/Patient-CenteredSoftwareSolutions/Cms" element={<CMSMandates />} />
        <Route path="/Services/Patient-CenteredSoftwareSolutions/BlueButtons" element={<BlueButton />} />
        <Route path="/Services/Patient-CenteredSoftwareSolutions/Consentmanagement" element={<ConsentManagement />} />
        <Route path="/Services/Patient-CenteredSoftwareSolutions/Comprehensive" element={<Comprehensive />} />
        <Route path="/Services/Patient-CenteredSoftwareSolutions/Secure&Affordable" element={<Secure />} />
        <Route path="/Services/Patient-CenteredSoftwareSolutions/Easyclams" element={<Easyclams />} />
        <Route path="/Services/Patient-CenteredSoftwareSolutions/Interoperability" element={<Interoperability />} />
        <Route path="/Services/Patient-CenteredSoftwareSolutions/Payer" element={<Payer />} />
        {/* Our services */}
        <Route path="/Services/Ourservices/HealthcareIntegration" element={<HealthcareIntegration />} />
        <Route path="/Services/Ourservices/Custom" element={<Custom />} />
        <Route path="/Services/Ourservices/Ehr" element={<Ehr />} />
        <Route path="/Services/Ourservices/Lis" element={<Lis />} />
        <Route path="/Services/Ourservices/Hl7" element={<Hl7 />} />
        <Route path="/Services/Ourservices/FhirHealth" element={<Fhirhealth />} />
        <Route path="/Services/Ourservices/MirthConnect" element={<MirthConnect />} />
        <Route path="/Services/Ourservices/Telemedicine" element={<Telemedicine />} />
        <Route path="/Services/Ourservices/Hiippa" element={<Hiippa />} />
        <Route path="/Services/Ourservices/AdvanceHDA" element={<HDA />} />
        <Route path="/Services/Ourservices/Revenue" element={<Revenue />} />
        <Route path="/Services/Ourservices/AI-Driven-Healthcare-Innovations" element={<ADHI />} />
        <Route path="/Services/Ourservices/PPES" element={<PPES />} />
        <Route path="/Services/Ourservices/Blockchain-Powered-Healthcare-Security" element={<BlockchainPoweredHealthcareSecurity />} />
      </Routes>

    </BrowserRouter>

  );
}

export default App;